import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { formatDistance } from "@/components/Store/shared/storeDistance/storeDistance.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { DamImage } from "@/utils/dam.utils";

type StoreDirectionsResultComponentProps = {
    originLabel: string;
    storeName: string;
    distance: number;
    onChangeOriginClick: () => void;
};

export const StoreDirectionsResultComponent = ({
    originLabel,
    storeName,
    distance,
    onChangeOriginClick
}: StoreDirectionsResultComponentProps) => {
    const { t } = useGranite();

    return (
        <>
            <div
                className={cn(
                    "tw:flex tw:gap-2 tw:p-2 tw:border tw:border-primary tw:rounded"
                )}
                onClick={onChangeOriginClick}
            >
                <p
                    className={cn(
                        "tw:flex tw:gap-1 tw:items-center tw:grow tw:shrink tw:basis-full"
                    )}
                >
                    <i className={cn("las la-map-marker")} />
                    <span
                        className={cn("tw:break-all tw:w-full")}
                        dangerouslySetInnerHTML={{ __html: originLabel }}
                    />
                </p>
                <i
                    className={cn(
                        "las la-lg la-arrow-right",
                        "tw:flex tw:flex-col tw:justify-center"
                    )}
                />
                <p
                    className={cn(
                        "tw:flex tw:gap-1 tw:items-center tw:grow tw:shrink tw:basis-full"
                    )}
                >
                    {/** biome-ignore lint/a11y/useAltText: <TODO> */}
                    <img
                        className={cn("tw:block")}
                        src={DamImage.icon.maps.icon}
                        width={"16"}
                        height={"16"}
                    />
                    <span className={cn("tw:break-all tw:w-full")}>
                        Hubo {storeName}
                    </span>
                </p>
            </div>
            <p className={cn("tw:flex tw:leading-6 tw:my-2 tw:mr-1")}>
                {t("storeDirections.result.routeLength")}
                <span className={cn("tw:font-bold tw:ml-2")}>
                    {formatDistance(distance)}
                </span>
            </p>
            <Button
                type={"button"}
                color={"link"}
                onClick={onChangeOriginClick}
                className={cn("tw:p-0")}
            >
                <i className={cn("las la-angle-left")} />
                {t("storeDirections.result.changeOrigin")}
            </Button>
        </>
    );
};
